<template>
  <div class="barcode-container">
      <div style="transform: scale(0.6) translateX(-5%); transform-origin: top right;">
        <svg class="barcode" 
          jsbarcode-format="code128"
          :jsbarcode-value="fiscalCode"
          jsbarcode-textmargin="0"
          jsbarcode-margin="0"
          jsbarcode-width="2.4"
          jsbarcode-height="60"
          jsbarcode-displayvalue=false
          jsbarcode-fontoptions="bold">
        </svg>
    </div>
    <div class="fiscalCode-text">*{{ fiscalCode }}*</div> 
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";

export default {
  name: "BarcodeFiscalCode",
  props: {
    fiscalCode: { type: String, required: true }
  },
  mounted() {
    this.generateBarcode();
  },
  watch: {
    fiscalCode() {
      this.generateBarcode();
    }
  },
  methods: {
    generateBarcode() {
      if (!this.fiscalCode) return;
      JsBarcode(".barcode").init();
    }
  }
};
</script>

<style scoped>
.barcode-container {
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}
canvas {
  display: block;
}
.fiscalCode-text {
  font-family: "Courier New", monospace;
  font-size: 14px !important;
  margin-top: -20px;
  margin-right: 60px;
  text-align: right;
}
</style>
